import { openDB } from 'idb';

const dbName = '__repa';
const storeName = 'formdata';
let dbPromise = null;

if (typeof window !== 'undefined') {
  dbPromise = openDB(dbName, 1, {
    upgrade (db) {
      db.createObjectStore(storeName);
    }
  });
}

const storage = {
  async get (key) {
    return (await dbPromise).get(storeName, key);
  },
  async set (key, val) {
    return (await dbPromise).put(storeName, val, key);
  },
  async delete (key) {
    return (await dbPromise).delete(storeName, key);
  },
  async clear () {
    return (await dbPromise).clear(storeName);
  },
  isSupported () {
    if (typeof window === 'undefined') return false;
    return ('indexedDB' in window);
  }
};

export default storage;
